import React from 'react';
import { Link } from 'react-router-dom';
import BlogFooter from 'components/BlogFooter';
import styles from './styles.module.scss';

const BLOG_POST = {
  slug: 'stop-zoom-happy-hour-bond-in-slack-teams',
  category: 'Team culture',
  title: 'Stop Booking Another Zoom Happy Hour. Bond in Slack or Teams Instead',
  excerpt:
    'Practical Slack and Teams bonding ideas that take five minutes, skip the calendar guilt, and feel less forced.',
  author: 'Casey / TryTrivia Content',
  date: 'August 22, 2026',
  readTime: '8 min read',
  image:
    'https://images.pexels.com/photos/7709166/pexels-photo-7709166.jpeg?auto=compress&cs=tinysrgb&w=1600'
};

const Blogs = () => (
  <main className={styles.blogPage}>
    <header className={styles.navigation}>
      <div className={styles.navigationInner}>
        <Link className={styles.logo} to='/blog'>
          <span className={styles.logoMark}>?</span>
          <span>Trivia</span>
        </Link>
        <nav className={styles.navLinks} aria-label='Main navigation'>
          <a href='https://trytrivia.co/slack/'>Slack</a>
          <a href='https://trytrivia.co/microsoft-teams/'>Teams</a>
          <a href='https://trytrivia.co/'>Home</a>
          <Link className={styles.loginLink} to='/login'>
            Get started
          </Link>
        </nav>
      </div>
    </header>

    <section className={styles.hero}>
      <div className={styles.heroContent}>
        <p className={styles.eyebrow}>The Trivia blog</p>
        <h1>Better team bonding, without another meeting.</h1>
        <p className={styles.heroText}>
          Ideas, playbooks, and practical advice for making hybrid work feel more human.
        </p>
      </div>
      <div className={styles.heroDecoration} aria-hidden='true'>
        <span>?</span>
        <span>✦</span>
      </div>
    </section>

    <section className={styles.content} aria-labelledby='latest-heading'>
      <div className={styles.sectionIntro}>
        <div>
          <p className={styles.eyebrow}>Latest from Trivia</p>
          <h2 id='latest-heading'>Ideas worth sharing with your team</h2>
        </div>
        <p>
          Short, practical reads for HR and People Ops teams building connection across Slack,
          Microsoft Teams, and everywhere work happens.
        </p>
      </div>

      <article className={styles.featuredCard}>
        <div className={styles.featuredImage}>
          <img src={BLOG_POST.image} alt='Laptops and headsets on a table' />
          <span className={styles.imageLabel}>Featured article</span>
        </div>
        <div className={styles.featuredCopy}>
          <p className={styles.postCategory}>{BLOG_POST.category}</p>
          <h3>{BLOG_POST.title}</h3>
          <p className={styles.excerpt}>{BLOG_POST.excerpt}</p>
          <div className={styles.postMeta}>
            <span>{BLOG_POST.author}</span>
            <span>{BLOG_POST.date}</span>
            <span>{BLOG_POST.readTime}</span>
          </div>
          <Link className={styles.readButton} to={`/blog/${BLOG_POST.slug}`}>
            Read the article <span aria-hidden='true'>↗</span>
          </Link>
        </div>
      </article>
    </section>

    <section className={styles.cta} aria-labelledby='cta-heading'>
      <div>
        <p className={styles.eyebrow}>Make work more human</p>
        <h2 id='cta-heading'>Five-minute team bonding, right where work happens.</h2>
      </div>
      <div className={styles.ctaLinks}>
        <a href='https://trytrivia.co/slack/'>Try Trivia in Slack</a>
        <a href='https://trytrivia.co/microsoft-teams/'>Try Trivia in Teams</a>
      </div>
    </section>

    <BlogFooter />
  </main>
);

export default Blogs;
